module.exports = __webpack_public_path__ + "img/warning.1c7858f7.svg";